import { ERROR_ACTION, WAIT_FOR_ACTION } from "redux-wait-for-action";

export const actionTypes = {
    USER_WELCOME_REQUEST_POST_FAILURE: "USER_WELCOME_REQUEST_POST_FAILURE",
    USER_WELCOME_REQUEST_POST_REQUEST: "USER_WELCOME_REQUEST_POST_REQUEST",
    USER_WELCOME_REQUEST_POST_SUCCESS: "USER_WELCOME_REQUEST_POST_SUCCESS"
};

export const actionCreators = {
    postRequest: (email) => ({
        type: actionTypes.USER_WELCOME_REQUEST_POST_REQUEST,
        payload: { email },
        [WAIT_FOR_ACTION]: actionTypes.USER_WELCOME_REQUEST_POST_SUCCESS,
        [ERROR_ACTION]: actionTypes.USER_WELCOME_REQUEST_POST_FAILURE
    }),
    postSuccess: (email: Array<any>) => ({
        type: actionTypes.USER_WELCOME_REQUEST_POST_SUCCESS,
        payload: { email }
    }),
    postFailure: (error: Error) => ({
        type: actionTypes.USER_WELCOME_REQUEST_POST_FAILURE,
        error
    })
};

export default {
    create: actionCreators,
    type: actionTypes
};
